<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">TNA Form No.</label>
                                <input type="number" v-model="search_data.form_no" v-validate="{ regex: /^[0-9]+$/ }"
                                    id="form_no" name="form_no" class="form-control form-control-sm"
                                    placeholder="Search by form No" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="household_number">Household Number</label>
                                <input type="text" v-model="search_data.household_number" id="household_number"
                                    name="household_number" placeholder="Search by HH No"
                                    class="form-control form-control-sm" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">Household Head Name</label>
                                <input type="text" v-model="search_data.name" id="name" name="name"
                                    placeholder="Search by Name" class="form-control form-control-sm" />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_village_id">Village</label>
                                <select v-model="search_data.c_village_id" id="c_village_id" name="c_village_id"
                                    class="form-control form-control-sm">
                                    <option selected :value="''">Select a village</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id">{{
                                            village.id
                                    }} : {{ village.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="c_training_trade_id">Training Trade</label>
                                <select v-model="search_data.c_training_trade_id" id="c_training_trade_id"
                                    name="c_training_trade_id" class="form-control form-control-sm">
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option v-for="(trade, index) in trades" :key="index" v-bind:value="trade.id">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="batch_no">Batch No</label>
                                <select v-model="search_data.batch_no" id="batch_no" name="batch_no"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3 mt-1">
                                <label for="bank_id">Select Bank</label>
                                <select v-model="search_data.c_bank_id" id="bank_id" name="bank_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Bank</option>
                                    <option v-for="bank in banks" v-bind:value="bank.id" :key="bank.id">
                                        {{ bank.desc }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
                            Search
                        </button>
                    </form>
                </b-card>
                <b-card>
                    <div v-if="trainees.total > 0" class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
                            <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                                <template v-slot:button-content>
                                    <i class="fa fa-cog"></i>
                                </template>
                                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
                                    <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                                        <input type="checkbox" v-model="selected" :value="checkboxArray"
                                            :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
                                    </span>
                                </b-dropdown-form>
                            </b-dropdown>
                            <download-excel class="btn btn-light float-right" :fetch="fetchData"
                                :fields="trainee_bank_fields" :meta="json_meta" :before-generate="startDownload"
                                :before-finish="finishDownload" worksheet="Trainee Bank" name="trainee-bank.xls">
                                Download Trainee With Bank
                            </download-excel>

                            <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                                <div v-if="loading" class="spinner-border spinner-border-sm text-muted"
                                    style="margin-bottom : 2px;">
                                </div>
                                Download PDF
                            </button>
                        </div>
                    </div>

                    <div class="table-responsive scrollable-table" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Trainee Name</th>
                                    <th>Fathers Name</th>
                                    <th>Bank Name</th>
                                    <th>Account No</th>
                                    <th>Branch</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(trainee, index) in trainees.data" :key="index">
                                    <td>{{ trainees.from + index }}</td>
                                    <td>
                                        <router-link :to="{ name: 'traineeView', params: { trainee_id: trainee.id } }"
                                            tag="a" target="_blank">{{ trainee.rep_name ? trainee.rep_name :
                                                    trainee.name
                                            }}
                                        </router-link>
                                    </td>
                                    <td>{{ trainee.rep_father_husband_name ? trainee.rep_father_husband_name :
                                            trainee.father_husband_name
                                    }}</td>
                                    <td>
                                        {{
                                                trainee.trainee_bank
                                                    ? trainee.trainee_bank.bank.desc
                                                    : "N/A"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                                trainee.trainee_bank
                                                    ? trainee.trainee_bank.account_no
                                                    : "N/A"
                                        }}
                                    </td>
                                    <td>
                                        {{
                                                trainee.trainee_bank
                                                    ? trainee.trainee_bank.branch_name
                                                    : "N/A"
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 v-if="!flag" class="text-center text-secondary">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    page: {
        title: "Create Trainee",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            loading: false,
            title: "Search Trainee",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Trainee",
                    active: true
                }
            ],
            trainees: {},
            search_data: {
                form_no: '',
                household_number: '',
                name: '',
                c_village_id: '',
                c_training_trade_id: '',
                batch_no: '',
                c_bank_id: '',
            },
            villages: [],
            traineeBank: {},
            banks: [],
            trades: [],
            flag: false,
            trainee_bank_fields: {

                'Trainees Name': {
                    callback: (value) => {
                        return `${value.rep_name ? value.rep_name : value.name}`;
                    }
                },
                'Trainees Fathers Name': {
                    callback: (value) => {
                        return `${value.rep_father_husband_name ? value.rep_father_husband_name : value.father_husband_name}`;
                    }
                },
                'Village': 'village.desc',
                'Bank Name': {
                    callback: (value) => {
                        return `${value.trainee_bank ? value.trainee_bank.bank.desc : "N/A"}`;
                    }
                },
                'Branch': {
                    callback: (value) => {
                        return `${value.trainee_bank ? value.trainee_bank.branch_name : "N/A"}`;
                    }
                },
                'Total Attendance': {
                    callback: (value) => {
                        return `${value.total_present_attendance_count ? value.total_present_attendance_count : "0"}`;
                    }
                },
                'Trade Name - Batch': {
                    callback: (value) => {
                        return `${value.trade_desc} - ${value.batch_no}`;
                    }
                },
                'Field Book No': {
                    callback: (value) => {
                        return `${value.field_book_sl ? value.field_book_sl : "N/A"}`;
                    }
                },
                'Trainee Conveyances': {
                    callback: (value) => {
                        return `${value.trainee_conveyances ? value.trainee_conveyances : "0"}`;
                    }
                },
                'Sub Total': {
                    callback: (value) => {
                        return `${value.sub_total_amount ? value.sub_total_amount : "0"}`;
                    }
                },
                'Vat': {
                    callback: (value) => {
                        return `${value.total_vat ? value.total_vat : "0"}`;
                    }
                },
                'Tax': {
                    callback: (value) => {
                        return `${value.total_tax ? value.total_tax : "0"}`;
                    }
                },
                'Total Amount': {
                    callback: (value) => {
                        return `${value.total_amount ? value.total_amount : "0"}`;
                    }
                },
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            checkboxArrays: ['Form No.', 'Household Number', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Trainee Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book'],
            selected: ['Name', 'Father Name', 'Rep Name', 'Rep Father Name'],
        };
    },

    mounted() {
        this.getCodes();
        this.getBanks();
        this.getTrainingTrade();
    },
    methods: {
        async dowonloadPdf() {
            this.loading = true
            let response = await http.post("api/trainees/bank/report/download_batch", this.search_data);
            var data = []
            try {
                // console.log(response.data.trainees)
                // return
                response.data.trainees.forEach(function (item) {
                    data.push([
                        item.rep_name ? item.rep_name : item.name,
                        item.rep_father_husband_name ? item.rep_father_husband_name : item.father_husband_name,
                        item.trainee_bank ? item.trainee_bank.bank.desc : "N/A",
                        item.trainee_bank? item.trainee_bank.account_no : "N/A",
                        item.trainee_bank? item.trainee_bank.branch_name : "N/A",
                    ])
                })
            }
            catch (e) {
                console.log(e.message)
            }

            const doc = new jsPDF()
            autoTable(doc, {
                head: [['Trainee Name', 'Fathers Name', 'Bank Name', 'Account No', 'Branch']],
                body: data,
            })
            doc.save('trainee-bank-report.pdf')
            this.loading = false
        },
        getCodes() {
            http.get("api/ses/codes").then(response => {
                if (!response.error) {
                    let data = response.data;
                    this.villages = data.villages;
                }
            });
        },
        search() {
            http.post("api/trainees/bank/search", this.search_data).then(response => {
                if (!response.error) {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                }
            });
        },
        getBanks() {
            http.get("api/trainee/bank/getBanks/").then(response => {
                if (!response.error) {
                    this.banks = response.data.banks;
                }
            });
        },
        getTrainingTrade() {
            http.get("api/getTrainingTrade/").then(response => {
                if (!response.error) {
                    let data = response.data;
                    this.trades = data.trades;
                }
            });
        },
        getResults(page = 1) {
            http.post('api/trainees/bank/search?page=' + page, this.search_data)
                .then(response => {
                    this.flag = true;
                    this.trainees = response.data.trainees;
                });
        },
        async fetchData() {
            const response = await http.post("api/trainees/bank/report/download_batch", this.search_data);
            return response.data.trainees;
        },
        startDownload() {
            alert('It will take some time, Loading...');
        },
        finishDownload() {
            alert('Download completed.');
        },
        isVisible(row) {
            const matchedValue = this.checkboxArrays.find(
                v => row === v
            );

            if (!matchedValue) {
                return true;
            }
            return this.selected.includes(matchedValue);
        }
    },
};
</script>
<style>
.scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
